import {
    ERROR_MIN_8_CHARS,
    ERROR_REQUIRED_FIELDS,
    ERROR_NEWPASS_NEWPASS2,
    ERROR_OLD_AND_NEW_PASS,
    ERROR_LOGINID_NEWPASSWORD
} from "../../../../utils/messages";
import { EMPTY_STRING } from '../../../../utils/constants'
import { CLIENT_ID } from "../../../../config/settings";
import { loadState } from "../../../../store/localStorage";

function isEmpty(string) {
    return EMPTY_STRING === string;
}

function validate(payload) {

    let prompt = [];
    let minLength = 8
    if (isEmpty(payload.username)
        || isEmpty(payload.nPassword)
        || isEmpty(payload.nPassword2)
        || isEmpty(payload.cPassword)) {
        prompt.push(ERROR_REQUIRED_FIELDS);
    } else if (minLength > payload.username.length
        || minLength > payload.nPassword.length
        || minLength > payload.cPassword.length) {
        prompt.push(ERROR_MIN_8_CHARS);
    } else if (payload.username === payload.nPassword) {
        prompt.push(ERROR_LOGINID_NEWPASSWORD);
    } else if(payload.cPassword === payload.nPassword){
        prompt.push(ERROR_OLD_AND_NEW_PASS);
    } else if (payload.nPassword !== payload.nPassword2) {
        prompt.push(ERROR_NEWPASS_NEWPASS2);
    }
    return prompt;
}

function isAuthenticated() {
    let state = loadState()
    return  state 
    && state.auth.isAuthenticated 
    && getCookie(CLIENT_ID) === state.auth.credentials.access_token
}

function getCookie(name) {
    if (document.cookie) {
        var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        if (match) return match[2];
    }

}


export {
    validate,
    isAuthenticated
};